import localStorage from 'app/utils/local-storage';

export async function fetcher(body, options) {
  const { url = '/api/graph' } = options;
  const token = localStorage.getItem('token');
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        authorization: `Bearer ${token}`,
        'content-type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    return await res.json();
  } catch (err) {
    if (__DEV__) {
      console.error(err);
    }
    throw new Error('can not fetch data');
  }
}
